import React, { useMemo, useEffect } from "react";
import useState from "react-usestateref";
import { Button } from "@material-ui/core";
import Select from "react-select";
import countryList from "react-select-country-list";
// import world from "../image/phone-call(1).png";

import world from "../image/phone-call(1).webp";

import logo from "../image/logo.webp";

import { sendMessageQuate } from "../config/apiCall";
import { sendMessageQuateDetails } from "../config/apiCall";
import { sendServiceContacts } from "../config/apiCall";
import { sendfooterServiceContact } from "../config/apiCall";

import httpService from "../config/httpCall";

import { toastAlert } from "../config/toastAlert";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate, Redirect } from "react-router-dom";
import {
  ScrollingProvider,
  useScrollSection,
  Section,
} from "react-scroll-section";
import indiaflag from "../image/india_flag.webp";
import Twiticon from "../image/ai/Mask group.svg";

function Footer() {
  const initialFormValue = {
    email: "",
    userName: "",
    comments: "",
    ids: "",
    country: "",
    telegram: "",
    skype: "",
  };

  const initialQuateValues = {
    quateEmail: "",
    quateuserName: "",
    quatecountry: "",
    quateIDs: "",
    quateMessage: "",
    quateskype: "",
    quatetelegram: "",
  };

  const [formValue, setFormValue] = useState(initialFormValue);
  const [quateValue, setquateValue] = useState(initialQuateValues);

  const [mobileValue, setMobileValue] = useState();
  const [quateMobileValue, setquateMobileValue] = useState();
  const [ValidateNameError, setValidateNameError] = useState(false);
  const [ValidateEmailError, setValidateEmailError] = useState(false);
  const [ValidateCommentsError, setValidateCommentsError] = useState(false);
  const [validationErrors, setvalidationErrors] = useState("");
  const [validateMobilesError, setValidateMobilesError] = useState(false);
  const [validateCountryError, setvalidateCountryError] = useState(false);
  const [closePopup, setclosePopup] = useState("modal");

  const [quateUserNameErr, setquateUserNameErr] = useState(false);
  const [quateEmailErr, setquateEmailErr] = useState(false);
  const [quateCountryErr, setquateCountryErr] = useState(false);
  const [quateMessageErr, setquateMessage] = useState(false);
  const [quateIDsErr, setquateIDsErr] = useState(false);
  const [qatevalidationErrors, setQuatevalidationErrors] = useState("");
  const [QuatevalidateMobilesError, setQuatevalidateMobilesError] =
    useState(false);
  const [MobileCode, setMobileCode] = useState();

  const history = useNavigate();

  const { email, userName, comments, ids, country, skype, telegram } =
    formValue;
  const {
    quateEmail,
    quateuserName,
    quatecountry,
    quateIDs,
    quateMessage,
    quateskype,
    quatetelegram,
  } = quateValue;

  const handleChangeData = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let formData = { ...formValue, ...{ [name]: value } };
      setFormValue(formData);
    } catch (error) {}
  };

  const validation = async (validateName) => {
    try {
      const errors = {};
      if (!validateName.userName) {
        setValidateNameError(true);
        errors.userName = "Must Enter Your Name";
      } else {
        setValidateNameError(false);
      }

      if (!validateName.country) {
        setvalidateCountryError(true);
        errors.country = "Must Enter Country Name";
      } else {
        setvalidateCountryError(false);
      }
      if (!validateName.ids) {
        setquateIDsErr(true);
        errors.ids = "Enter your Country";
      } else {
        setquateIDsErr(false);
      }
      if (!validateName.email) {
        setValidateEmailError(true);
        errors.email = "Must Enter Email Address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(validateName.email)
      ) {
        setValidateEmailError(true);
        errors.email = "Invalid Email Address";
      } else {
        setValidateEmailError(false);
      }
      if (!validateName.comments) {
        setValidateCommentsError(true);
        errors.comments = "Must Enter Your Comments";
      } else if (validateName.comments) {
        var textLenghtCheck = validateName.comments.length;
        if (textLenghtCheck > 300) {
          errors.comments = "Only allowed 300 characters. ";
          setValidateCommentsError(true);
        }
      } else {
        setValidateCommentsError(false);
      }
      if (!mobileValue) {
        setValidateMobilesError(true);
        errors.mobile = "Must Enter Your Mobile Number";
      } else {
        var numberStr = mobileValue.toString();
        var res = mobileValue.replace(MobileCode, "");
        if (res == "" || res == undefined || res == null) {
          setValidateMobilesError(true);
          errors.mobile = "Must Enter Your Mobile Number";
        } else {
          setValidateMobilesError(false);
        }
      }
      setvalidationErrors(errors);
    } catch (error) {}
  };

  const sendMessage = async () => {
    try {
      setclosePopup("modal");

      validation(formValue);
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formValue.email)) {
      } else {
        if (
          formValue.email != "" &&
          formValue.comments != "" &&
          formValue.userName != "" &&
          formValue.country != "" &&
          mobileValue != undefined
        ) {
          formValue["mobileValue"] = mobileValue;
          var obj = {
            apiUrl: httpService.sendMessageApiQuote,
            payload: formValue,
          };
          var messageSent = await sendMessageQuate(obj);
          if (messageSent.status) {
            // toastAlert("success", messageSent.Message);
            history("/sucesspage");
            formValue["mobileValue"] = "";
            formValue["email"] = "";
            formValue["userName"] = "";
            formValue["comments"] = "";
          } else {
            toastAlert("error", messageSent.Message);
          }
        } else {
        }
      }
    } catch (error) {}
  };

  const quateChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let formQuateData = { ...quateValue, ...{ [name]: value } };
    setquateValue(formQuateData);
  };

  const sendQuoate = async () => {
    quateValidation(quateValue);
    setclosePopup("modal");
    if (
      quateValue.quateEmail != "" &&
      quateValue.quateMessage != "" &&
      quateValue.quateuserName != "" &&
      quateValue.quateIDs != "" &&
      quateValue.quatecountry != "" &&
      quateMobileValue != undefined
    ) {
      quateValue["mobileValue"] = quateMobileValue;
      var obj = {
        apiUrl: httpService.sendMessageQuate,
        payload: quateValue,
      };
      var messageSent = await sendMessageQuateDetails(obj);
      if (messageSent.status) {
        // history('/thankscareer');
        window.location.href = "https://beleaftechnologies.com/sucesspage";
      } else {
        toastAlert("error", messageSent.Message);
      }
    } else {
    }
  };
  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);
  const changeHandler = (value) => {
    setValue(value);
    // console.log(value, "value");
    quateValue.quatecountry = value.label;
    formValue.country = value.label;
  };

  const quateValidation = async (validateName) => {
    try {
      const errorsQuate = {};
      if (!validateName.quateuserName) {
        setquateUserNameErr(true);
        errorsQuate.userName = "Enter your name";
      } else {
        setquateUserNameErr(false);
      }

      if (!validateName.quatecountry) {
        setquateCountryErr(true);
        errorsQuate.country = "Enter your country";
      } else {
        setquateCountryErr(false);
      }
      if (!validateName.quateIDs) {
        setquateIDsErr(true);
        errorsQuate.quateIDs = "Enter your ID";
      } else {
        setquateIDsErr(false);
      }

      if (!validateName.quateEmail) {
        setquateEmailErr(true);
        errorsQuate.email = "Enter your email address";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          validateName.quateEmail
        )
      ) {
        setquateEmailErr(true);
        errorsQuate.email = "Invalid Email Address";
      } else {
        setquateEmailErr(false);
      }
      if (!validateName.quateMessage) {
        setquateMessage(true);
        errorsQuate.comments = "Enter your message";
      } else if (validateName.quateMessage) {
        var textLenghtCheck = validateName.quateMessage.length;
        if (textLenghtCheck > 300) {
          errorsQuate.comments = "Only allowed 300 characters. ";
          setquateMessage(true);
        }
      } else {
        setquateMessage(false);
      }
      if (!quateMobileValue) {
        setQuatevalidateMobilesError(true);
        errorsQuate.mobile = " Enter Your Mobile Number";
      } else {
        var numberStr = quateMobileValue.toString();
        var res = quateMobileValue.replace(MobileCode, "");
        if (res == "" || res == undefined || res == null) {
          setQuatevalidateMobilesError(true);
          errorsQuate.mobile = " Enter Your Mobile Number";
        } else {
          setQuatevalidateMobilesError(false);
        }
      }
      setQuatevalidationErrors(errorsQuate);
    } catch (error) {}
  };

  const handleOnChange = (value, countryObj, e, formattedValue) => {
    setMobileValue(value);
    setquateMobileValue(value);
    setMobileCode(countryObj.dialCode);
  };

  //NewForm popup==========================================================

  const NewFormValue = {
    newformmediumValue: "",
    newformmedium: "",
    newformmessage: "",
    newformmobile: "",
    newformuserName: "",
    newformmobilecode: "",
  };

  const [newValue, setnewValue] = useState(NewFormValue);

  const { newformuserName, newformmessage } = newValue;

  const [
    newformmediumValueErr,
    setnewformmediumValueErr,
    newformmediumValueErrref,
  ] = useState(false);
  const [newformmediumErr, setnewformmediumErr] = useState(false);
  const [newformmessageErr, setnewformmessageErr] = useState(false);
  const [newformmobileErr, setnewformmobileErr] = useState(false);
  const [newformuserNameErr, setnewformuserNameErr] = useState(false);
  const [newformmobilecodeErr, setnewformmobilecodeErr] = useState(false);
  const [validationErr, setvalidationErr] = useState(false);

  const handleNewFormChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let formData = { ...newValue, ...{ [name]: value } };
      setnewValue(formData);
    } catch (error) {}
  };
  const [selectedPlatform, setSelectedPlatform] = useState("WhatsApp");
  const [platformInput, setPlatformInput] = useState("");

  const handlePlatformSelect = (platform) => {
    setSelectedPlatform(platform);
    setPlatformInput("");
    newValue["newformmediumValue"] = "";
    newValue["newformmedium"] = platform;
    setnewformmediumValueErr(true);
  };

  const handlePlatformInputChange = (e) => {
    setPlatformInput(e.target.value);
    newValue["newformmediumValue"] = e.target.value;
  };

  const [NewFormNMobileCode, setNewFormNMobileCode] = useState();
  const [NewFormMobileValue, setNewFormMobileValue] = useState();
  const [NewFormcountry, setNewFormcountry] = useState();

  const handleNewFormMobile = (value, countryObj, e, formattedValue) => {
    setNewFormMobileValue(value);
    setNewFormNMobileCode(countryObj.dialCode);
    setNewFormcountry(countryObj.name);
    newValue["newformmobilecode"] = countryObj.dialCode;
    newValue["newformmobile"] = value;
    newValue["NewFormcountry"] = countryObj.name;
  };

  const cancelpopup = () => {};

  const validate = async () => {
    try {
      var error = {};

      if (newValue.newformmedium == "") {
        setnewformmediumErr(true);
        error.newformmedium = "Must Enter the field";
      } else {
        setnewformmediumErr(false);
      }

      if (newValue.newformmedium == "Email") {
        if (newValue.newformmediumValue == "") {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Must Enter the field ";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
            newValue.newformmediumValue
          )
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Invalid Mail";
        } else {
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }
      if (newValue.newformmedium == "Skype") {
        if (newValue.newformmediumValue == "") {
          error.newformmediumValue = "Must Enter the field ";
          setnewformmediumValueErr(true);
        } else {
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }

      if (newValue.newformmedium == "Telegram") {
        if (!newValue.newformmediumValue) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Must Enter the field ";
        } else {
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }
      if (newValue.newformmedium == "WhatsApp") {
        if (!newValue.newformmediumValue) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Must Enter the field ";
        } else {
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }

      if (newValue.newformmessage == "") {
        setnewformmessageErr(true);
        error.newformmessage = "Must Enter the field";
      } else {
        setnewformmessageErr(false);
      }
      if (newValue.newformmobile == "") {
        setnewformmobileErr(true);
        error.newformmobile = "Must Enter the field";
      } else {
        var numberStr = NewFormMobileValue.toString();
        var res = NewFormMobileValue.replace(NewFormNMobileCode, "");
        if (res == "" || res == undefined || res == null) {
          setnewformmobileErr(true);
          error.newformmobile = " Enter Your Mobile Number";
        } else {
          setnewformmobileErr(false);
        }
      }
      if (newValue.newformuserName == "") {
        setnewformuserNameErr(true);
        error.newformuserName = "Must Enter the field";
      } else {
        setnewformuserNameErr(false);
      }
      setvalidationErr(error);
    } catch (error) {}
  };

  const sendServiceContact = async () => {
    if (selectedPlatform == "") {
      newValue["newformmedium"] = "WhatsApp";
    } else {
      newValue["newformmedium"] = selectedPlatform;
    }
    validate(newValue);
    if (
      newValue.newformmedium != "" &&
      newValue.newformmedium != null &&
      newValue.newformmedium != undefined &&
      newValue.newformmediumValue != "" &&
      newValue.newformmediumValue != null &&
      newValue.newformmediumValue != undefined &&
      newValue.newformmessage != "" &&
      newValue.newformmessage != null &&
      newValue.newformmessage != undefined &&
      newValue.newformmobile != "" &&
      newValue.newformmobile != null &&
      newValue.newformmobile != undefined &&
      newValue.newformuserName != "" &&
      newValue.newformuserName != null &&
      newValue.newformuserName != undefined &&
      newValue.newformmobilecode != "" &&
      newValue.newformmobilecode != null &&
      newValue.newformmobilecode != undefined
    ) {
      var obj = {
        apiUrl: httpService.sendServiceContactDetails,
        payload: newValue,
      };
      var messageSent = await sendServiceContacts(obj);
      if (messageSent.status == true) {
        cancelpopup();
        // window.close();
        // self.close();
        // web_window.close();
        history("/sucesspage");
        toastAlert("success", messageSent.Message);
        window.location.reload();
      } else {
        toastAlert("error", messageSent.Message);
      }
    } else {
      validate(newValue);

      toastAlert("error", "Invalid Fields");
    }
  };
  //New form Footer
  const NewFormfooterValue2 = {
    newformfootermediumValue: "",
    newformfootermedium: "WhatsApp",
    newformfootermessage: "",
    newformfootermobile: "",
    newformfooteruserName: "",
    newformfootermobilecode: "",
  };

  const [newValue2, setnewValue2] = useState(NewFormfooterValue2);

  const { newformfooteruserName, newformfootermessage } = newValue2;

  const [
    newformfootermediumValueErr,
    setnewformfootermediumValueErr,
    newformfootermediumValueErrref,
  ] = useState(false);
  const [newformfootermediumErr, setnewformfootermediumErr] = useState(false);
  const [newformfootermessageErr, setnewformfootermessageErr] = useState(false);
  const [newformfootermobileErr, setnewformfootermobileErr] = useState(false);
  const [newformfooteruserNameErr, setnewformfooteruserNameErr] =
    useState(false);
  const [newformfootermobilecodeErr, setnewformfootermobilecodeErr] =
    useState(false);
  const [validationErr2, setvalidationErr2] = useState(false);

  const handleNewFormfooterChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let formData = { ...newValue2, ...{ [name]: value } };
      setnewValue2(formData);
    } catch (error) {}
  };
  const [selectedPlatform2, setSelectedPlatform2] = useState("WhatsApp");
  const [platformInput2, setPlatformInput2] = useState("");

  const handlePlatformSelect2 = (platform) => {
    setSelectedPlatform2(platform);
    setPlatformInput2("");
    newValue2["newformfootermediumValue"] = "";
    newValue2["newformfootermedium"] = platform;
    setnewformfootermediumValueErr(true);
  };

  const handlePlatformInputChange2 = (e) => {
    setPlatformInput2(e.target.value);
    newValue2["newformfootermediumValue"] = e.target.value;
  };

  const [NewFormfooterNMobileCode, setNewFormfooterNMobileCode] = useState();
  const [NewFormfooterMobileValue, setNewFormfooterMobileValue] = useState();
  const [NewFormfootercountry, setNewFormfootercountry] = useState();
  const handleNewFormfooterMobile2 = (value, countryObj, e, formattedValue) => {
    setNewFormfooterMobileValue(value);
    setNewFormfooterNMobileCode(countryObj.dialCode);
    setNewFormfootercountry(countryObj.name);
    newValue2["newformfootermobilecode"] = countryObj.dialCode;
    newValue2["newformfootermobile"] = value;
    newValue2["NewFormfootercountry"] = countryObj.name;
  };
  // console.log(newValue2.newformfootermedium ,"newValue2.newformfootermedium ")
  const validate2 = async () => {
    try {
      var error = {};

      // if (newValue2.newformfootermedium == "") {
      //   setnewformfootermediumValueErr(true);
      //   error.newformfootermediumValue = "Must Enter the field";
      // } else {
      //   setnewformfootermediumValueErr(false);
      // }

      if (newValue2.newformfootermedium == "Email") {
        if (newValue2.newformfootermediumValue == "") {
          setnewformfootermediumValueErr(true);
          error.newformfootermediumValue = "Must Enter the field ";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
            newValue2.newformfootermediumValue
          )
        ) {
          setnewformfootermediumValueErr(true);
          error.newformfootermediumValue = "Invalid Mail";
        } else {
          setnewformfootermediumValueErr(false);
        }
      } else {
        setnewformfootermediumValueErr(false);
      }
      if (newValue2.newformfootermedium == "Skype") {
        if (newValue2.newformfootermediumValue == "") {
          error.newformfootermediumValue = "Must Enter the field ";
          setnewformfootermediumValueErr(true);
        } else {
          setnewformfootermediumValueErr(false);
        }
      } else {
        setnewformfootermediumValueErr(false);
      }

      if (newValue2.newformfootermedium == "Telegram") {
        if (!newValue2.newformfootermediumValue) {
          setnewformfootermediumValueErr(true);
          error.newformfootermediumValue = "Must Enter the field ";
        } else {
          setnewformfootermediumValueErr(false);
        }
      } else {
        setnewformfootermediumValueErr(false);
      }
      if (newValue2.newformfootermedium == "WhatsApp") {
        // console.log("p----")
        if (!newValue2.newformfootermediumValue) {
          setnewformfootermediumValueErr(true);
          error.newformfootermediumValue = "Must Enter the field ";
        } else {
          setnewformfootermediumValueErr(false);
        }
      } else {
        setnewformfootermediumValueErr(false);
      }

      if (newValue2.newformfootermessage == "") {
        setnewformfootermessageErr(true);
        error.newformfootermessage = "Must Enter the field";
      } else {
        setnewformfootermessageErr(false);
      }
      if (newValue2.newformfootermobile == "") {
        setnewformfootermobileErr(true);
        error.newformfootermobile = "Must Enter the field";
      } else {
        var numberStr = NewFormfooterMobileValue.toString();
        var res = NewFormfooterMobileValue.replace(
          NewFormfooterNMobileCode,
          ""
        );
        if (res == "" || res == undefined || res == null) {
          setnewformfootermobileErr(true);
          error.newformfootermobile = " Enter Your Mobile Number";
        } else {
          setnewformfootermobileErr(false);
        }
      }
      if (newValue2.newformfooteruserName == "") {
        setnewformfooteruserNameErr(true);
        error.newformfooteruserName = "Must Enter the field";
      } else {
        setnewformfooteruserNameErr(false);
      }
      setvalidationErr2(error);
    } catch (error) {}
  };

  const sendfooterContact = async () => {
    if (selectedPlatform == "") {
      newValue2["newformmedium"] = "WhatsApp";
    } else {
      newValue2["newformmedium"] = selectedPlatform;
    }
    validate2(newValue2);
    if (
      newValue2.newformfootermedium != "" &&
      newValue2.newformfootermedium != null &&
      newValue2.newformfootermedium != undefined &&
      newValue2.newformfootermediumValue != "" &&
      newValue2.newformfootermediumValue != null &&
      newValue2.newformfootermediumValue != undefined &&
      newValue2.newformfootermessage != "" &&
      newValue2.newformfootermessage != null &&
      newValue2.newformfootermessage != undefined &&
      newValue2.newformfootermobile != "" &&
      newValue2.newformfootermobile != null &&
      newValue2.newformfootermobile != undefined &&
      newValue2.newformfooteruserName != "" &&
      newValue2.newformfooteruserName != null &&
      newValue2.newformfooteruserName != undefined &&
      newValue2.newformfootermobilecode != "" &&
      newValue2.newformfootermobilecode != null &&
      newValue2.newformfootermobilecode != undefined
    ) {
      var obj = {
        apiUrl: httpService.sendfooterServiceContact,
        payload: newValue2,
      };
      var messageSent = await sendfooterServiceContact(obj);
      if (messageSent.status == true) {
        cancelpopup();
        history("/sucesspage");
        toastAlert("success", messageSent.Message);
      } else {
        toastAlert("error", messageSent.Message);
      }
    } else {
      validate2(newValue2);

      toastAlert("error", "Invalid Fields");
    }
  };
  return (
    <div>
      <div className="footer_back">
        <div className="container-fluid">
          <div className="contact_new_for">
            <div className="form_map_s">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15720.723226845737!2d78.0991425!3d9.9188949!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdfaa2098994d2054!2sBeleaf%20Technologies%20Blockchain%20Software%20Development%20Company!5e0!3m2!1sen!2sin!4v1666342144538!5m2!1sen!2sin"
                width="600"
                height="450"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="map_content_section">
              <h6>Contact Us</h6>
              <p className="paragraph_content">
                We will be happy to answer your questions
              </p>
              <div className="icon_address icon_addressfirst-child">
                <div className="icon">
                  <i className="bi bi-geo-alt"></i>
                </div>
                <div className="data_conte">
                  <p>India - Madurai</p>
                  <span>
                    5/24, Bharathiyar 7th street,
                    <br />
                    S.S. Colony, Madurai,
                    <br />
                    Postalcode : 625 016,
                    <br />
                    Tamil Nadu,
                    <br />
                    India.{" "}
                  </span>
                </div>
              </div>
              <div className="icon_address icon_addressfirst-child">
                <div className="icon">
                  <i className="bi bi-geo-alt"></i>
                </div>
                <div className="data_conte">
                  <p>India - Thane </p>
                  <span>
                    12, 4th floor Krishnasthal CHS,
                    <br />
                    Mira Gaon Mira Road East,Thane,
                    <br />
                    Postal Code : 401 107,
                    <br />
                    Maharastra,
                    <br />
                    India.{" "}
                  </span>
                </div>
              </div>
              <div className="icon_address">
                <div className="icon">
                  <i className="bi bi-envelope"></i>
                </div>

                <div className="data_conte">
                  <p>E-mail</p>
                  <span>business@beleaftechnologies.com</span> <br />
                  <span>hr@beleaftechnologies.com</span>
                </div>
              </div>
              <div className="icon_address">
                <div className="icon">
                  <i className="bi bi-telephone"></i>
                </div>

                <div className="data_conte">
                  <p>Phone number</p>
                  <span>+91 80567 86622</span>
                  <br />
                  <span>+91 79043 23274</span>
                </div>
              </div>
              <div className="icon_address">
                <div className="icon">
                  <i className="bi bi-telephone"></i>
                </div>

                <div className="data_conte">
                  <p>Contact HR</p>
                  <span>+91 7603980269</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Section id="Contact" className="footer_section">
        <section className="section" id="contact">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h6 className="contact-csss">Get In Touch</h6>
              </div>
            </div>
            <div className="mt-5 pt-2 row justify-content-center">
              <div className="col-lg-7">
                <div className="custom-form">
                  <div id="message"></div>

                  <form id="contact-form" className="av-invalid">
                    <div className="row">
                      <div className="col-lg-12">
                        {/* <div className="mt-3 form-group">
                          <div className="form-group">
                            <label>Name</label>
                            <input
                              name="userName"
                              placeholder="Your name"
                              id="name"
                              type="text"
                              className="form-control is-untouched is-pristine av-invalid form-control"
                              value={userName}
                              onChange={handleChangeData}
                            />
                          </div>
                          {ValidateNameError && ValidateNameError === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.userName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div> */}
                        <div className="mt-3 form-group">
                          <div className="form-group">
                            <label>Name</label>
                            <input
                              placeholder="Your name"
                              id="name"
                              type="text"
                              className="form-control is-untouched is-pristine av-invalid form-control"
                              name="newformfooteruserName"
                              value={newformfooteruserName}
                              onChange={handleNewFormfooterChange}
                            />
                          </div>
                          {newformfooteruserNameErr &&
                          newformfooteruserNameErr === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErr2.newformfooteruserName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div className="col-lg-12">
                        <div className="mt-3 form-group">
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              name="email"
                              placeholder="Your email"
                              id="email"
                              type="email"
                              className="form-control is-untouched is-pristine av-invalid form-control"
                              value={email}
                              onChange={handleChangeData}
                            />
                          </div>
                          {ValidateEmailError && ValidateEmailError === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErrors.email}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div> */}
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="mt-3 form-group">
                          <div className="form-group">
                            <label>Mobile Number</label>
                            <PhoneInput
                              country={"us"}
                              enableSearch={true}
                              // value={mobileValue}
                              // onChange={setMobileValue}
                              onChange={(
                                value,
                                countryObj,
                                e,
                                formattedValue
                              ) =>
                                handleNewFormfooterMobile2(
                                  value,
                                  countryObj,
                                  e,
                                  formattedValue
                                )
                              }
                            />
                          </div>
                          {newformfootermobileErr &&
                          newformfootermobileErr === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErr2.newformfootermobile}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {/* <div className="col-lg-6">
                        <div className="mt-3 form-group contactcountry">
                          <div className="form-group">
                            <label>Country</label>

                            <Select
                              options={options}
                              value={value}
                              onChange={changeHandler}
                            />
                          </div>
                        </div>
                      </div> */}
                      <div className="col-sm-12 pb-3 contact-medium-label">
                        <label>Contact Medium</label>
                        <div className="border_sledct">
                          <button
                            type="button"
                            className="btn dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {/* <i className="fa fa-whatsapp" aria-hidden="true"></i> */}
                            {selectedPlatform2 == "WhatsApp" ? (
                            <i className="fa-brands fa-whatsapp"></i>
                            ) : selectedPlatform2 == "Telegram" ? (
                              <i className="fa-brands fa-telegram"></i>
                            ) : selectedPlatform2 == "Skype" ? (
                              <i className="fa-brands fa-skype"></i>
                            ) : selectedPlatform2 == "Email" ? (
                              <i className="fa fa-envelope" aria-hidden="true"></i>
                            ) : (
                              ""
                            )}
                          </button>
                          <div className="dropdown-menu">
                            <a
                              className="dropdown-item"
                              onClick={() => handlePlatformSelect2("WhatsApp")}
                            >
                              <i className="fa-brands fa-whatsapp"></i>
                            </a>
                            <a
                              className="dropdown-item"
                              onClick={() => handlePlatformSelect2("Telegram")}
                            >
                              <i className="fa-brands fa-telegram"></i>
                            </a>
                            <a
                              className="dropdown-item"
                              onClick={() => handlePlatformSelect2("Skype")}
                            >
                              <i className="fa-brands fa-skype"></i>
                            </a>
                            <a
                              className="dropdown-item"
                              onClick={() => handlePlatformSelect2("Email")}
                            >
                              <i className="fa fa-envelope" aria-hidden="true"></i>
                            </a>
                          </div>
                          {selectedPlatform2 && (
                            <input
                             type={selectedPlatform2 === "WhatsApp"? "number":"text"}
                              className="form-control"
                              placeholder={`Enter your ${selectedPlatform2} ${
                                selectedPlatform2 == "Email"
                                  ? "Address"
                                  : "Number"
                              }`}
                              value={platformInput2}
                              onChange={handlePlatformInputChange2}
                            />
                          )}
                        </div>
                        {/* {
  newformmediumValueErrref.current ? ( */}
                        <span className="text-danger">
                          {validationErr2.newformfootermediumValue}
                        </span>
                        {/* ) : (
    "llll"
  )
} */}
                      </div>
                      <div className="col-sm-12  pt-0 pb-0 contact-medium-label">
                        <label>Tell us about your project</label>

                        <textarea
                          className="form-control"
                          placeholder="Message"
                          rows="5"
                          name="newformfootermessage"
                          value={newformfootermessage}
                          onChange={handleNewFormfooterChange}
                        ></textarea>
                        {newformfootermessageErr &&
                        newformfootermessageErr === true ? (
                          <span className="text-danger">
                            {" "}
                            {validationErr2.newformfootermessage}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-lg-6">
                        <div className="mt-3 form-group">
                          <div className="form-group">
                            <label>Skype</label>
                            <input
                              name="skype"
                              placeholder="Your skype"
                              id="skype"
                              type="skype"
                              className="form-control is-untouched is-pristine av-invalid form-control"
                              value={skype}
                              onChange={handleChangeData}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mt-3 form-group">
                          <div className="form-group">
                            <label>Telegram</label>
                            <input
                              name="telegram"
                              placeholder="Your telegram mmm"
                              id="telegram"
                              type="telegram"
                              className="form-control is-untouched is-pristine av-invalid form-control"
                              value={telegram}
                              onChange={handleChangeData}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="mt-3 form-group">
                          <label>Message</label>
                          <textarea
                            name="comments"
                            id="comment"
                            rows="5"
                            className="form-control"
                            placeholder="Your message"
                            value={comments}
                            onChange={handleChangeData}
                          ></textarea>
                        </div>
                        {ValidateCommentsError &&
                        ValidateCommentsError === true ? (
                          <span className="text-danger">
                            {" "}
                            {validationErrors.comments}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div> */}

                    <div className="pt-3 pb-0 mt-1 banner_text_section footer_form_d">
                      <Button onClick={() => sendfooterContact()}>
                        Send Message
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Section>

      <footer className="bg-footer">
        <div className="footer_menyu_sss">
          <div className="link_section ">
            <a href="https://telegram.me/BeleafSoftTech" target="_blank">
              <i className="bi bi-telegram blob"></i>
            </a>
            <span>Telegram</span>
          </div>

          <div className="link_section">
            <a href="https://wa.me/7904323274" target="_blank">
              <i className="bi bi-whatsapp blob"></i>
            </a>
            <span>Whatsapp</span>
          </div>
          {/* <div className="link_section">
            <a href=" https://wa.me/7904323274" target="_blank">
              <i className="bi bi-whatsapp blob"></i>
            </a>
            <span>Whatsapp</span>
          </div> */}
          {/* <div className="link_section">
            <a
              href="https://join.skype.com/invite/wg5IW8g4Uaca"
              target="_blank"
            >
              <i className="bi bi-skype blob"></i>
            </a>
            <span>Skype</span>
          </div> */}

          <div className="link_section">
            <a href="tel:+91 80567 86622" target="_blank">
              <i className="bi bi-telephone-fill blob"></i>
            </a>
            <span>Call</span>
          </div>
          <div className="link_section">
            <a href="mailto:business@beleaftechnologies.com" target="_blank">
              <i className="bi bi-envelope-fill blob"></i>
            </a>
            <span>Mail</span>
          </div>
        </div>
        {/* <div className="menu-button">
          <img src={world} />
          <a href="https://t.me/BeleafTechnologies" target="_blank">
            <i className="fab fa-telegram-plane"></i>
          </a>
          <a href=" https://wa.me/8056786622" target="_blank">
            <i className="fab fa-whatsapp"></i>
          </a>
          <a href="https://join.skype.com/invite/wg5IW8g4Uaca" target="_blank">
            <i className="fab fa-skype"></i>
          </a>
        </div> */}
        <div className="container-fluid">
          <div className="py-5 row">
            <div className="col-md-4 col-lg-3">
              <div className="mt-0">
                <img src={logo} className="logo_d" alt="logo" />
              </div>
            </div>
            <div className="col-md-4 col-lg-3">
              <div className="icon_address icon_addressfirst-child">
                <div className="icon">
                  <i className="bi bi-geo-alt"></i>
                  {/* <img src={indiaflag} style={{ width: 25, height: 12.5 }}></img> */}
                </div>
                <div className="data_conte">
                  <p>India - Madurai</p>
                  <span>
                    5/24, Bharathiyar 7th street,
                    <br />
                    S.S. Colony, Madurai,
                    <br />
                    Postalcode : 625 016,
                    <br />
                    Tamil Nadu,
                    <br />
                    India.{" "}
                  </span>
                </div>
              </div>
              {/* <div className="mt-2 pl-0 pl-lg-5">
                <h6 className="text-white text-uppercase f-16 header_secle">
                  Centralized Crypto Exchange
                </h6>
                <ul className="list-unstyled footer-link mt-3 mb-0">
                  <li>
                    <Link to="/cryptocurrency-exchange-development">
                      Centralized Exchange Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/decentralized-exchange-development">
                      Decentralized Exchange Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/p2p-cryptocurrency-exchange">
                      P2P Exchange Development
                    </Link>
                  </li>
                  
                  <li>
                    <Link to="/crypto-derivatives-exchange-development">
                      Derivatives Exchange development
                    </Link>
                  </li>
                  <li>
                    <Link to="/market-making-bot">Market Making Bot</Link>
                  </li>
                  <li>
                    <Link to="/arbitrage">Arbitrage Bot</Link>
                  </li>
                  <li>
                    <Link to="/smart-order-routing">
                      Smart Order Routing (SOR)
                    </Link>
                  </li>
                  <li>
                    <Link to="/cryptocurrency-exchange-development">
                      Over-the-Counter (OTC)
                    </Link>
                  </li>
                  <li>
                    <Link to="/whitelabel-crypto-exchange">
                      Whitelabel Crypto Exchange
                    </Link>
                  </li>
                  <li>
                    <Link to="/local-bitcoin-clone">Local Bitcoin Clone</Link>
                  </li>
                </ul>
              </div> */}
            </div>
            <div className="col-md-4 col-lg-3">
              <div className="icon_address icon_addressfirst-child">
                <div className="icon">
                  <i className="bi bi-geo-alt"></i>
                </div>
                <div className="data_conte">
                  <p>India - Thane</p>
                  <span>
                    12, 4th floor Krishnasthal CHS,
                    <br />
                    Mira Gaon Mira Road East,Thane,
                    <br />
                    Maharastra.
                    <br />
                    Postal Code - 401107
                    <br />
                    India.{" "}
                  </span>
                </div>
              </div>
              {/* <div className="mt-2">
                <h6 className="text-white text-uppercase f-16 header_secle">
                  {" "}
                  Clone Script
                </h6>
                <ul className="list-unstyled footer-link mt-3 mb-0">
                  <li>
                    <a> Binance Clone Script</a>
                  </li>
                  <li>
                    <a> Kraken Clone Script</a>
                  </li>
                  <li>
                    <a> Wazirx Clone Script</a>
                  </li>
                  <li>
                    <a>Paxful Clone Script</a>
                  </li>
                  <li>
                    <a>Localbitcoins Clone Script</a>
                  </li>
                  <li>
                    <a>OpenSea Clone Script</a>
                  </li>
                  <li>
                    <a>PancakeSwap Clone Script</a>
                  </li>
                  <li>
                    <a>CryptoKitties Clone Script</a>
                  </li>
                  <li>
                    <a>Sushi Swap Clone Script</a>
                  </li>
                  <li>
                    <a>Uniswap Clone Script</a>
                  </li>
                  <li>
                    <a>DinoSwap Clone Script</a>
                  </li>
                  <li>
                    <a>Rarible Clone Script</a>
                  </li>
                  <li>
                    <a>Axie Infinity</a>
                  </li>
                </ul>
              </div> */}
            </div>
            <div className="col-md-4 col-lg-3">
              <div className="mt-4">
                <div className="mt-4">
                  <h6 className="text-white text-uppercase f-16 header_secle mb-4">
                    Social Media
                  </h6>
                  <ul className="list-inline footer-social mb-0">
                    {/* <li className="list-inline-item">
                      <a
                        className="rounded"
                        target="_blank"
                        href="https://www.facebook.com/Beleaf-Technologies-115471241167315"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li> */}
                    <li className="list-inline-item">
                      <a
                        className="rounded"
                        target="_blank"
                        href="https://www.linkedin.com/company/beleaf-technologies-blf/"
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        className="rounded"
                        target="_blank"
                        href="https://pin.it/3bOarDn"
                      >
                        <i className="fab fa-pinterest"></i>
                      </a>
                    </li>
                    {/* <li className="list-inline-item">
                      <a
                        className="rounded"
                        target="_blank"
                        href="https://x.com/BeleafSoftTech"
                      >
                        <img src={Twiticon}></img>
                      </a>
                    </li> */}
                    {/* <i className="fab fa-twitter"></i> */}
                    <li className="list-inline-item">
                      <a
                        className="rounded"
                        target="_blank"
                        href="https://www.instagram.com/beleaftechnologies/"
                      >
                        <i
                          className="fa-brands fa-instagram"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        className="rounded"
                        href="https://telegram.me/BeleafSoftTech"
                        target="_blank"
                      >
                        <i className="fa-brands fa-telegram"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        className="rounded"
                        href="https://join.skype.com/invite/wg5IW8g4Uaca"
                        target="_blank"
                      >
                        <i className="fa-brands fa-skype"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        className="rounded"
                        href="https://wa.me/7904323274"
                        target="_blank"
                      >
                        <i className="fa-brands fa-whatsapp"></i>
                      </a>
                    </li>
                    {/* <li className="list-inline-item">
                      <a
                        className="rounded"
                        href="https://wa.me/7904323274"
                        target="_blank"
                      >
                        <i className="fa fa-whatsapp" aria-hidden="true"></i>
                      </a>
                    </li> */}
                    <li className="list-inline-item">
                      <a
                        className="rounded"
                        href="mailto:business@beleaftechnologies.com"
                        target="_blank"
                      >
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-alt pt-3 pb-3">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <p className="text-white-50 mb-0">
                    © 2024 Beleaf Technologies All Rights Reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      <div id="Apply-footer" className="modal fade" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content ">
            <div className="modal-body">
              <div>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <h3>Apply Now</h3>
              <form>
                <div className="form-group row">
                  <div className="col-sm-12 pt-3 ">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                    />
                  </div>
                  <div className="col-sm-12 pt-3 ">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                    />
                  </div>
                  <div className="col-sm-12 pt-3 ">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone Number"
                    />
                  </div>
                  <div className="col-sm-12 pt-3 ">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Years of Experience"
                    />
                  </div>
                  <div className="col-sm-12 pt-3 ">
                    <div className="uploadfile">
                      <input type="file" className="form-control" />
                      <div className="flex_upload">
                        <i className="fas fa-file-upload"></i>
                        <p>Upload File</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="banner_text_section p-0 pb-0">
                      <Button className="m-0">Submit</Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="myModal" className="modal fade contact_model" role="dialog">
        <div className="modal-dialog modal-md">
          <div className="modal-content banner_ee_orjhe">
            <div className="modal-body">
              <button
                type="button"
                className="close contwcte"
                data-dismiss="modal"
                onClick={cancelpopup}
              >
                ×
              </button>
              <div className="row">
                <div className="col-lg-12 padid_a00">
                  <div className="CTA_card_pop">
                    <form>
                      <div className="form-group row">
                        <div className="col-sm-12 mb-3">
                          <label>Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            name="newformuserName"
                            value={newformuserName}
                            onChange={handleNewFormChange}
                          />
                          {newformuserNameErr && newformuserNameErr === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErr.newformuserName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="col-sm-12  pb-3">
                          <div className=" react-tel-input d-flex flex-column align-items-start">
                            <label>Mobile Number</label>

                            <PhoneInput
                              country={"us"}
                              enableSearch={true}
                              // value={newformmobile}
                              // onChange={setquateMobileValue}
                              onChange={(
                                value,
                                countryObj,
                                e,
                                formattedValue
                              ) =>
                                handleNewFormMobile(
                                  value,
                                  countryObj,
                                  e,
                                  formattedValue
                                )
                              }
                            />

                            {newformmobileErr && newformmobileErr === true ? (
                              <span className="text-danger">
                                {" "}
                                {validationErr.newformmobile}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                            {/* <div className="flag-dropdown ">
                        <div
                          className="selected-flag"
                          title="India: + 91"
                          tabindex="0"
                          role="button"
                          aria-haspopup="listbox"
                        >
                          <div className="flag in">
                            <div className="arrow"></div>
                          </div>
                        </div>
                      </div> */}
                          </div>
                        </div>
                        <div className="col-sm-12 pb-3 contact-medium-label">
                          <label>Contact Medium</label>
                          <div className="border_sledct">
                            <button
                              type="button"
                              className="btn dropdown-toggle"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {/* <i className="fa fa-whatsapp" aria-hidden="true"></i> */}
                              {selectedPlatform == "WhatsApp" ? (
                                <i className="fa-brands fa-whatsapp"></i>
                              ) : selectedPlatform == "Telegram" ? (
                                <i className="fa-brands fa-telegram"></i>
                              ) : selectedPlatform == "Skype" ? (
                                <i className="fa-brands fa-skype"></i>
                              ) : selectedPlatform == "Email" ? (
                                <i
                                  className="fa fa-envelope"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                ""
                              )}
                            </button>
                            <div className="dropdown-menu">
                              <a
                                className="dropdown-item"
                                onClick={() => handlePlatformSelect("WhatsApp")}
                              >
                               <i className="fa-brands fa-whatsapp"></i>
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={() => handlePlatformSelect("Telegram")}
                              >
                                <i className="fa-brands fa-telegram"></i>
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={() => handlePlatformSelect("Skype")}
                              >
                                <i className="fa-brands fa-skype"></i>
                              </a>
                              <a
                                className="dropdown-item"
                                onClick={() => handlePlatformSelect("Email")}
                              >
                                <i
                                  className="fa fa-envelope"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>
                            {selectedPlatform && (
                              <input
                                type="text"
                                className="form-control"
                                placeholder={`Enter your ${selectedPlatform} ${
                                  selectedPlatform == "Email"
                                    ? "Address"
                                    : selectedPlatform == "Skype" ||
                                      selectedPlatform == "Telegram"
                                    ? "Id"
                                    : "Number"
                                }`}
                                value={platformInput}
                                onChange={handlePlatformInputChange}
                              />
                            )}
                          </div>
                          {/* {
  newformmediumValueErrref.current ? ( */}
                          <span className="text-danger">
                            {validationErr.newformmediumValue}
                          </span>
                          {/* ) : (
    "llll"
  )
} */}
                        </div>
                        <div className="col-sm-12  pt-0 pb-0 contact-medium-label">
                          <label>Tell us about your project</label>

                          <textarea
                            className="form-control"
                            placeholder="Message"
                            rows="5"
                            name="newformmessage"
                            value={newformmessage}
                            onChange={handleNewFormChange}
                          ></textarea>
                          {newformmessageErr && newformmessageErr === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErr.newformmessage}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12 pr-0">
                        <div className="banner_text_section p-0">
                          <button
                            className="MuiButtonBase-root MuiButton-root MuiButton-text m-0"
                            tabindex="0"
                            type="button"
                            onClick={() => sendServiceContact()}
                          >
                            Send Message
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                {/* <div className="col-lg-4">
                  <div className="popup_headeine">
                    <h2>Contact Us</h2>
                    <p>
                      We welcome and encourage you to share your ideas for your
                      business. Working with imaginative individuals is always a
                      joy for us.
                    </p>
                  </div>
                  <div className="imgae_CTA_section">
                    <img
                      src={require("../image/cloudinary/Saly-2_zwjt2d.webp")}
                      alt="contact us"
                      className="CTAclass"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
